(function (angular) {
    'use strict';

    angular.module('app')
        .controller('newsletterController', newsletterController);

    newsletterController.$inject = [
        '$http'
    ];

    function newsletterController(
        $http
    ) {
        var vm = this;

        // properties.
        vm.email = null;
        vm.loading = false;

        // methods.
        vm.signup = signup;

        /**
         * Sign up to the newsletter.
         *
         * @return {void}
         */
        function signup() {
            vm.loading = true;

            // sign up user.
            $http.post('/api/users/newsletter', {email: vm.email}).then(
                function successCallback() {
                    vm.loading = false;
                    vm.signedup = true;
                },
                function errorCallback() {
                    vm.loading = false;
                }
            );
        }
    }

}(angular));
